import { NgModule } from '@angular/core';
import { RouterModule, Routes, provideRouter, withComponentInputBinding } from '@angular/router';

import { IsAuthenticatedGuard } from './authentication/guards/is-authenticated.guard';
import { Error404Component } from './core/components/error404/error404.component';

const routes: Routes = [
  {
    path: 'authentication',
    loadChildren: () => import('./authentication/authentication.module').then((module) => module.AuthModule)
  },
  {
    path: '',
    loadChildren: () => import('./core/core.module').then((module) => module.CoreModule),
    canActivate: [IsAuthenticatedGuard]
  },
  {
    path: 'error404',
    component: Error404Component
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { paramsInheritanceStrategy: 'always' })],
  exports: [RouterModule],
  providers: [provideRouter(routes, withComponentInputBinding())]
})
export class AppRoutingModule {}
